import { render, staticRenderFns } from "./Promotion_add_pos_free.vue?vue&type=template&id=1da6afcc&scoped=true&"
import script from "./Promotion_add_pos_free.vue?vue&type=script&lang=js&"
export * from "./Promotion_add_pos_free.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_add_pos_free.vue?vue&type=style&index=0&id=1da6afcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6afcc",
  null
  
)

export default component.exports